import { render, staticRenderFns } from "./attribuer.vue?vue&type=template&id=020d43d8"
import script from "./attribuer.vue?vue&type=script&lang=js"
export * from "./attribuer.vue?vue&type=script&lang=js"
import style0 from "./attribuer.vue?vue&type=style&index=0&id=020d43d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports